import { fmt } from '../utils/format';

// Compact per-queue depth visualization. One row per queue.
// Bars scale to the max total across all queues so relative sizes are meaningful.
export const QueueDepthBar = ({ queues = [] }) => {
  if (!queues.length) {
    return (
      <div className="flex items-center justify-center h-[200px] text-xs text-darkGrayColor">
        No queues reported.
      </div>
    );
  }

  const max = Math.max(
    1,
    ...queues.map(q => (q.pending ?? 0) + (q.reserved ?? 0) + (q.delayed ?? 0))
  );

  return (
    <ul className="flex flex-col gap-3">
      {queues.map(q => {
        const pending = q.pending ?? 0;
        const reserved = q.reserved ?? 0;
        const delayed = q.delayed ?? 0;
        const total = pending + reserved + delayed;
        const pctPending = (pending / max) * 100;
        const pctReserved = (reserved / max) * 100;
        const pctDelayed = (delayed / max) * 100;

        return (
          <li key={q.name} className="flex flex-col gap-1.5">
            <div className="flex items-baseline justify-between gap-2">
              <span className="text-xs font-medium text-blackColor truncate">
                {q.name}
              </span>
              <span className="text-[11px] text-darkGrayColor">
                {fmt(total)} total
              </span>
            </div>
            <div className="flex h-2 w-full overflow-hidden rounded bg-lightGrayColor">
              {pctPending > 0 && (
                <div
                  className="bg-purpleColor transition-all duration-200"
                  style={{ width: `${pctPending}%` }}
                  title={`Pending: ${pending}`}
                />
              )}
              {pctReserved > 0 && (
                <div
                  className="bg-darkBlueColor transition-all duration-200"
                  style={{ width: `${pctReserved}%` }}
                  title={`Reserved: ${reserved}`}
                />
              )}
              {pctDelayed > 0 && (
                <div
                  className="bg-yellowColor transition-all duration-200"
                  style={{ width: `${pctDelayed}%` }}
                  title={`Delayed: ${delayed}`}
                />
              )}
            </div>
            <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-[11px] text-darkGrayColor">
              <span className="flex items-center gap-1">
                <span className="inline-block w-2 h-2 rounded-full bg-purpleColor" />
                Pending {fmt(pending)}
              </span>
              <span className="flex items-center gap-1">
                <span className="inline-block w-2 h-2 rounded-full bg-darkBlueColor" />
                Reserved {fmt(reserved)}
              </span>
              <span className="flex items-center gap-1">
                <span className="inline-block w-2 h-2 rounded-full bg-yellowColor" />
                Delayed {fmt(delayed)}
              </span>
            </div>
          </li>
        );
      })}
    </ul>
  );
};
